/* OGC Digital Business Card page JS */
(function () {
  function initOgcDbcPage() {
    var root = document.querySelector('.ogc-dbc-page');
    if (!root) return;

    var els = root.querySelectorAll('[data-reveal]');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function(el){ el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      els.forEach(function (el) { io.observe(el); });
    }

    if (window.lucide) { window.lucide.createIcons(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOgcDbcPage);
  } else {
    initOgcDbcPage();
  }
})();
